import { Paragraph } from "docx";
import { getDateObjectLocal } from "../../../helpers/Date";
import { tabSignatureLine } from "../summary/tablines1";
import { gutachterField } from "./gutachterField";

export const gutachterSectionArray = (schueler, klausur, companies, user) => {
  const city = companies.find(
    (c) => c.id === parseInt(klausur.companyId)
  )?.city;
  return klausur.gutachter === "ga1"
    ? gutachterField(user)
    : [
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        new Paragraph(""),
        tabSignatureLine(
          `${city}, den ${getDateObjectLocal(new Date()).short}\t`,
          `${user?.firstName} ${user?.lastName}`
        ),
      ];
};
